import { render, staticRenderFns } from "./DashboardModalPendenciasEmAnalise.vue?vue&type=template&id=a1eef890"
import script from "./DashboardModalPendenciasEmAnalise.vue?vue&type=script&lang=js"
export * from "./DashboardModalPendenciasEmAnalise.vue?vue&type=script&lang=js"
import style0 from "./DashboardModalPendenciasEmAnalise.vue?vue&type=style&index=0&id=a1eef890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports